import React, { useState } from "react";
import { useEffect } from "react";
import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "routes.js";
import { AppointmentRoutes } from "views/Appointment";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "slices/userSlice";
import { getCheckInStatus } from "slices/userSlice";

export function usePermissions() {
  const { user } = useSelector(userSelector);

  function checkPermission(value) {
    if (user?.role === "admin") return true;
    return !!user?.permissions?.some(i => i.name === value);
  }

  return { checkPermission };
}


function Dashboard(props) {
  const dispatch = useDispatch();
  const { checkPermission } = usePermissions();
  const { user, logout } = useSelector(userSelector);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Sidebar toggle state
  const mainPanel = React.useRef();
  const location = useLocation();

  const defaultIframeUrl = process.env.REACT_APP_OPI_IFRAME_URL;

  let finalIframeUrl = defaultIframeUrl;

  if (user?.role !== "admin" && user?.sub_user) {
    const extension = user?.sub_user?.webphone_extension;
    const password = user?.sub_user?.webphone_password;

    finalIframeUrl = `https://asterisks.algovicrm.com/?username=${encodeURIComponent(extension)}&password=${encodeURIComponent(password)}&wssUrl=wss%3A%2F%2Fasterisks.algovicrm.com%3A8089%2Fws&url=asterisks.algovicrm.com&from_cid=9218764328`;
  }

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  let allowedUrls
  if (user?.permissions) {
    allowedUrls = user?.permissions?.map(i => i.url)?.filter(url => url)?.map(url => (url.startsWith("/") ? url?.slice(1) : url));
  }
  else {
    localStorage.removeItem("persist:root");
    setTimeout(() => {
      window.location.replace("/login")
    }, 200);
  }
  console.log(allowedUrls, 'allowedUrls');
  const filteredRoutes = routes
    .filter(prop => {
      const routePath = prop?.path === "" ? "dashboard" : prop?.path;
      return (
        user?.role === "admin" ||
        allowedUrls?.some(url => routePath.startsWith(url))
      );
    })
    .map(route => {
      if (route.path === "staff-timesheet") {
        return {
          ...route,
          title: user?.role === "admin" ? "Staff Timesheet" : "Timesheet",
        };
      }

      return route;
    });

  console.log(filteredRoutes, 'filteredRoutes');
  console.log(routes, 'allroutes');
  const [checkinStatus, setCheckinStatus] = useState();

  useEffect(() => {

    dispatch(getCheckInStatus((success, data) => {
      if (success) {
        setCheckinStatus(data.data.user.checked_in);
      } else {
        console.log("Failed to fetch check-in status", data);
      }
    }));
  }, [checkinStatus]);

  return (
    <div className="wrapper">
      <Sidebar
        {...props}
        user={user}
        allowedUrls={allowedUrls}
        routes={filteredRoutes}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />
      <div className={`main-panel ${isSidebarOpen ? "collaped" : ""}`} ref={mainPanel}>
        <DemoNavbar {...props} toggleSidebar={toggleSidebar} />
        <Routes>
          {filteredRoutes.map((prop, key) => (
            prop?.path !== "appointments" && (
              <Route path={prop.path} element={prop.component} key={key} />
            )
          ))}
          <Route path="/appointments/*" element={<AppointmentRoutes />} />
        </Routes>
        <Footer fluid />
      </div>
      {checkPermission('Webphone Access') && checkinStatus === 1 && (
        <div className="offcanvas offcanvas-end custom_canvas border-0" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
          <div className="offcanvas-header">
            <h5 className="offcanvas-title webphone_titile" id="offcanvasExampleLabel">Web Phone</h5>
            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div className="offcanvas-body webpone_area">
            {/* <div 
            id="webphone"
            > */}
            <iframe
              allow="microphone"
              style={{
                width: "100%",
                height: "99%",
              }}
              src={finalIframeUrl}
              // src={process.env.REACT_APP_OPI_IFRAME_URL}
              // className="invisible position-fixed z-0 pe-none "
              // src="https://asterisks.algovicrm.com/?username=2000&password=2IpN1MFZgeWOaQzYU1At&wssUrl=wss%3A%2F%2Fasterisks.algovicrm.com%3A8089%2Fws&url=asterisks.algovicrm.com&from_cid=9218764328" 

              frameborder="0">

            </iframe>

            {/* </div> */}

          </div>
        </div>
      )
      }
      <Outlet />
    </div>
  );
}

export default Dashboard;
